import { createGlobalStyle } from 'styled-components';
import reset from 'styled-reset';

import { LayoutConfig } from 'types/Config';
import { fontNormal, modalZIndex, pageScrollerZIndex } from './cssGlobalVariables';
import { Breakpoints, MQ, MQ_REDUCED_MOTION } from './cssMediaQueries';

export const GlobalStyle = createGlobalStyle<{ theme: { globalConfig: LayoutConfig; brandedConfig: LayoutConfig } }>`
    ${reset}

    .player-opened {
        overflow: hidden;
        width: 100%;
    }

    body {
        font-family: ${fontNormal}, sans-serif;
        color: var(--color-dark-body);
        background-color: var(--color-dark-background);
        -webkit-text-size-adjust: auto;
        cursor: default;
      	-webkit-touch-callout: none;
    	overflow: auto;
    	line-height: 1;
    }

    a {
        text-decoration: none;
        font-size: 16px;
        color: var(--color-dark-body);
        transition: all .2s ease-out;

        &:hover,
        &:active{
            color: var(--color-dark-body);
        }
    }

    :where(:focus-visible:not([tabindex='-1'])) {
        outline: var(--focus-outline-solid);
        outline-offset: 2px;
    }

    ${MQ_REDUCED_MOTION} {
        *:not(.motion-essential, .motion-essential *),
        *::before,
        *::after {
            animation-duration: 0.01ms !important;
            animation-iteration-count: 1 !important;
            transition-duration: 0.01ms !important;
            scroll-behavior: auto !important;
        }
    }

    #main-content:focus,
    #main-content h1:focus {
        outline: none;
    }

    .font-svg path {
        fill: var(--color-dark-body);
    }

    .ScrollbarsCustom-Content {
        padding: 0 !important;
        min-height: auto !important;
    }

    .ScrollbarsCustom-Wrapper {
        right: 0 !important;
    }

    .ScrollbarsCustom-TrackY {
        z-index: ${pageScrollerZIndex} !important;
        background: transparent !important;
        height: 100% !important;
        top: 0 !important;
        bottom: 0 !important;
        width: 4px !important;
        right: 4px !important;

        .ScrollbarsCustom-Thumb {
            background: ${(props) => props.theme.globalConfig.scrollbar_color} !important;
            border-radius: 4px;
        }
    }

    .react-toast-notifications__container {
      bottom: 64px !important;
      z-index: ${modalZIndex + 1} !important;
      padding-right: 16px !important;

      ${MQ(Breakpoints.m)} {
        bottom: auto !important;
        top: 64px !important;
        padding-right: 40px !important;
      }
    }
`;
